import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-497384ea"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "media-type" };
var _hoisted_2 = { class: "cover" };
var _hoisted_3 = ["src"];
var _hoisted_4 = { class: "title" };
var _hoisted_5 = ["innerHTML"];
import { onMounted, ref } from 'vue';
import { getAICoursePictureById } from '@/api/course';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mediaTypeTwo',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var id = route.query.id;
        console.log('id:', id);
        var state = ref({});
        var GetAICoursePictureById = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAICoursePictureById(id)];
                    case 1:
                        data = (_a.sent()).data;
                        state.value = data;
                        return [2 /*return*/];
                }
            });
        }); };
        onMounted(function () {
            GetAICoursePictureById();
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        src: state.value.imgCover,
                        alt: ""
                    }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(state.value.name), 1),
                _createElementVNode("div", {
                    class: "content",
                    innerHTML: state.value.richText
                }, null, 8, _hoisted_5)
            ]));
        };
    }
});
